function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import { GridMouseHandler } from '@deephaven/grid';
/**
 * Handles interaction with tables when the Linker tool is active
 */
class IrisGridColumnSelectMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
    this.cursor = null;
  }
  isActive() {
    var isSelectingColumn = this.irisGrid.props.isSelectingColumn;
    return isSelectingColumn;
  }
  isValidColumn(tableColumn) {
    if (tableColumn == null || tableColumn.isProxy === true) {
      return false;
    }
    var columnSelectionValidator = this.irisGrid.props.columnSelectionValidator;
    if (columnSelectionValidator != null) {
      return columnSelectionValidator(tableColumn);
    }
    return true;
  }
  updateColumnSelectionStatus() {
    var columnSelectionValidator = this.irisGrid.props.columnSelectionValidator;
    if (columnSelectionValidator != null) {
      columnSelectionValidator(null);
    }
  }
  getTableColumn(columnIndex) {
    if (columnIndex == null) {
      return null;
    }
    var model = this.irisGrid.props.model;
    var modelColumn = this.irisGrid.getModelColumn(columnIndex);
    if (modelColumn == null) {
      return null;
    }
    return model.columns[modelColumn];
  }
  onMove(gridPoint) {
    if (!this.isActive()) {
      return false;
    }
    var _this$irisGrid$props = this.irisGrid.props,
      columnAllowedCursor = _this$irisGrid$props.columnAllowedCursor,
      columnNotAllowedCursor = _this$irisGrid$props.columnNotAllowedCursor;
    var column = gridPoint.column;
    var tableColumn = this.getTableColumn(column);
    if (this.isValidColumn(tableColumn)) {
      this.cursor = columnAllowedCursor;
      this.irisGrid.setState({
        hoverSelectColumn: column
      });
    } else {
      this.cursor = columnNotAllowedCursor;
      this.irisGrid.setState({
        hoverSelectColumn: null
      });
    }
    return true;
  }

  // keeps linker cursor state during wheel event
  onWheel(gridPoint) {
    if (!this.isActive()) {
      return false;
    }
    var _this$irisGrid$props2 = this.irisGrid.props,
      columnAllowedCursor = _this$irisGrid$props2.columnAllowedCursor,
      columnNotAllowedCursor = _this$irisGrid$props2.columnNotAllowedCursor;
    var column = gridPoint.column;
    var tableColumn = this.getTableColumn(column);
    if (this.isValidColumn(tableColumn)) {
      this.cursor = columnAllowedCursor;
      this.irisGrid.setState({
        hoverSelectColumn: column
      });
    } else {
      this.cursor = columnNotAllowedCursor;
      this.irisGrid.setState({
        hoverSelectColumn: null
      });
    }

    // don't block wheel event from scrolling
    return {
      preventDefault: false,
      stopPropagation: false
    };
  }
  onLeave() {
    if (this.isActive()) {
      this.irisGrid.setState({
        hoverSelectColumn: null
      });
    }
    this.updateColumnSelectionStatus();
    return false;
  }
  onDown() {
    return this.isActive();
  }
  onClick(gridPoint) {
    if (!this.isActive()) {
      return false;
    }
    var column = gridPoint.column;
    var tableColumn = this.getTableColumn(column);
    if (tableColumn != null && this.isValidColumn(tableColumn)) {
      this.irisGrid.selectColumn(tableColumn);
    }
    return true;
  }
}
export default IrisGridColumnSelectMouseHandler;
//# sourceMappingURL=IrisGridColumnSelectMouseHandler.js.map